import { ChannelsWebSurvey } from '../../../../../shared/types/modules/channels-web-information';
import { Question } from './props';

export const initialValues: ChannelsWebSurvey = {
    type: 'V1',
    question1: [],
};

export const questionsV1: Question[] = [
    {
        id: 'question1',
        type: 'unique',
        options: [
            'Correo Electrónico',
            'Telefónico',
            'Mensajerías de correo físico',
            'Mensaje de texto',
            'Whatsapp',
        ],
    },
];

export const getQuestions = () => {
    return {
        type: 'V1',
        questions: questionsV1,
    };
};
